import { render, staticRenderFns } from "./MissingInformation.vue?vue&type=template&id=0141f8a4&"
import script from "./MissingInformation.vue?vue&type=script&lang=js&"
export * from "./MissingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports